<script setup lang="ts">
import { computed } from "vue";
import { PowerUpLayout } from "@vendata/power-up-clients-common";
import { adminLinks } from "@vendata/power-up-links";
import { linkToHrefWithHost } from "@saflib/links";
import { isDevelopmentDeployment } from "@saflib/vue";

const adminSidebarLinks = [
  { name: "Home", href: linkToHrefWithHost(adminLinks.home) },
  { name: "Transactions", href: linkToHrefWithHost(adminLinks.transactions) },
  { name: "Repairs", href: linkToHrefWithHost(adminLinks.repairs) },
  { name: "Test Utils", href: linkToHrefWithHost(adminLinks.testUtils) },
  { name: "Cron", href: linkToHrefWithHost(adminLinks.cronJobs) },
];

const devObservabilitySidebarLinks = computed(() => {
  if (!isDevelopmentDeployment()) {
    return [];
  }
  return [
    { name: "Errors", href: linkToHrefWithHost(adminLinks.errors) },
    { name: "Emails", href: linkToHrefWithHost(adminLinks.emails) },
    { name: "Logs", href: linkToHrefWithHost(adminLinks.logs) },
    { name: "Metrics", href: linkToHrefWithHost(adminLinks.metrics) },
    { name: "Events", href: linkToHrefWithHost(adminLinks.events) },
  ];
});

/** Logo-only top bar; sidebar provides admin navigation. */
const adminNavLinks: { name: string; href: string }[] = [];
</script>

<template>
  <PowerUpLayout
    nav-appearance="app"
    :disable-container="true"
    :navigation-links-override="adminNavLinks"
  >
    <div class="d-flex">
      <v-navigation-drawer permanent width="200" class="flex-grow-0">
        <v-list nav>
          <v-list-item
            v-for="link in adminSidebarLinks"
            :key="link.href"
            :href="link.href"
            :title="link.name"
            variant="text"
          />
          <template v-if="devObservabilitySidebarLinks.length">
            <v-divider class="my-2" />
            <v-list-subheader>Dev Observability</v-list-subheader>
            <v-list-item
              v-for="link in devObservabilitySidebarLinks"
              :key="link.href"
              :href="link.href"
              :title="link.name"
              variant="text"
            />
          </template>
        </v-list>
      </v-navigation-drawer>
      <div class="flex-grow-1">
        <router-view />
      </div>
    </div>
  </PowerUpLayout>
</template>
